import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/styles/C911Ced.scss';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import {CabezaCedula,IdentEsc,VersionCifras,ClaveEsc,CicloCenso,TotalAlumnos,Separador,SumaSet,TurnoNombre,ActHojas,PieCedulaMedia} from './ToolsCed';

// control de documentos
let tothoja=0;
function DatosCifrasCapa(props){
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;
  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  if (numhoja>tothoja){
    tothoja=numhoja;
  }
  return (
    <div>
      {Separador (poselem,reg1hoja)}
      {TurnoNombre([props.cifras.turno,props.cifras.turno1,props.cifras.turno2,props.cifras.turno3])}
      <Row><Col xs={12}><h6 className="font-weight-bold">I. ALUMNOS, GRUPOS Y DOCENTES</h6></Col></Row>
      <Row>
        <Col xs={7}>
          <Row>
            <Col xs={8}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={6}>&nbsp;</Col>
                <Col xs={2}>Total</Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={6} className="bordetransparente text-left">Alumnos</Col>
                <Col xs={2} className="borde"><NumberFormat value={props.cifras.alumtot} displayType={'text'} thousandSeparator={true}/></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={6}><div className="bordetransparente text-left"><p>Grupos</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupotot}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={6}><div className="bordetransparente text-left"><p>Docentes frente a grupo</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.doctot}</p></div></Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="text-center">
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div><p>Hom</p></div></Col>
                <Col xs={6}><div><p>Muj</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">              
                <Col xs={6} className="borde"><NumberFormat value={props.cifras.alumhom} displayType={'text'} thousandSeparator={true}/></Col>
                <Col xs={6} className="borde"><NumberFormat value={props.cifras.alummuj} displayType={'text'} thousandSeparator={true}/></Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
      <Row><Col xs={12}><h6 className="font-weight-bold">II. PERSONAL POR FUNCIÓN</h6></Col></Row>
      <Row>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold">Personal Directivo</Col>
                <Col xs={2} className="font-weight-bold borde text-center">{SumaSet([props.cifras.dircgpo,props.cifras.dirsgpo])}</Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Con grupo</Col>
                <Col xs={2} className="borde text-center">{props.cifras.dircgpo}</Col>               
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Sin grupo</Col>
                <Col xs={2} className="borde text-center">{props.cifras.dirsgpo}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold bordetransparente">Personal docente</Col>
                <Col xs={2} className="font-weight-bold borde text-center">{props.cifras.doc}</Col> 
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold">Personal Especial</Col>
                <Col xs={2} className="font-weight-bold borde text-center">{props.cifras.persesp}</Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold bordetransparente">Pers. Admvo.,Aux. y de Servs.</Col>
                <Col xs={2} className="font-weight-bold borde text-center">{props.cifras.admvo}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={7} className="font-weight-bold bordetransparente">Total de Personal</Col>
                <Col xs={2} className="font-weight-bold borde text-center">{props.cifras.perstot}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function LlenaCedula(){
  //  const { estad, fechac911 } = useSelector((state) => state.esc);
  const { estad } = useSelector((state) => state.esc);
  let cadena=[];
  let reg=0;
  let regcct=2;
  let regxanexo=3;
  let anexos=0;
  let anexolleno=0;
  let regsinanexo=0;
  let lianexo=0;
  let lsanexo=0;
  const Ciclo=CicloCenso(1);
  reg=estad.length;
  ActHojas(reg,regcct,regxanexo);
  if (reg>0){
    if (reg<=2){
      cadena.push(
      <div>
        <CabezaCedula/>
        <IdentEsc/>
        <Card border="dark" style={{ width: 'auto' }}>
          <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
          <Card.Body>
            <TotalAlumnos escuela={estad}/>
            {estad.map((items,index) => {return <DatosCifrasCapa cifras={items} regxanexo={regxanexo} indice={index} />})}
          </Card.Body>
        </Card>
        <PieCedulaMedia/>
      </div>);
    }else{
      cadena.push(
        <div>
          <CabezaCedula/>
          <IdentEsc/>
          <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold">E<VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <TotalAlumnos escuela={estad}/>
              {estad.map((items,index) => {
                if ((index>=0) && (index<=1)) {
                return <DatosCifrasCapa cifras={items} regxanexo={regxanexo} indice={index}/>
                }else{return[]}
                })}
            </Card.Body>
          </Card>
          <PieCedulaMedia/>
        </div>);
      anexos=(reg-regcct)/regxanexo;
      anexolleno=Math.trunc(anexos);
      regsinanexo=reg-regcct-(anexolleno*regxanexo);
      lianexo=regcct; /* comienza a partir del registro 2 y omite los registros 0 y 1 */
      lsanexo=regcct+regxanexo-1; /* abarca hasta el 4° registro incluyendo el registro 2 */
      if (anexolleno>0) {
        //anexos llenos
        for (let ii=1; ii <= anexolleno; ii++) {
          cadena.push(
            <div>
              <CabezaCedula/>
              <Card border="dark" style={{ width: 'auto'}}>
                <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
                <Card.Body>
                  <ClaveEsc cvect={estad[0].cvect}/>
                  {estad.map((items,index) => {if ((index>=lianexo) && (index<=lsanexo))
                    {return <DatosCifrasCapa cifras={items} regxanexo={regxanexo} indice={index}/>}else{return []}})
                  }
                </Card.Body>
              </Card>
              <PieCedulaMedia/>
            </div>);
          lianexo=lianexo+regxanexo;
          lsanexo=lsanexo+regxanexo;
        }
      }else{
        lsanexo=regcct+regsinanexo-1; /* abarca hasta el registro N incluyendo el registro 2 */
      }
      if (regsinanexo>0) {
        //anexos llenos
        cadena.push(
          <div>
            <CabezaCedula/>
            <Card border="dark" style={{ width: 'auto'}}>
              <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS  {Ciclo}</Card.Header>
              <Card.Body>
                <ClaveEsc cvect={estad[0].cvect}/>
                {estad.map((items,index) => {if ((index>=lianexo) && (index<=lsanexo)) 
                  {return <DatosCifrasCapa cifras={items} regxanexo={regxanexo} indice={index}/>}else{return []}})}
              </Card.Body>
            </Card>
            <PieCedulaMedia/>
          </div>);
      }
    }
  }
  return <Container padding="4rem">{cadena}</Container>;
} //LlenaCedula  

class CedCapa extends React.Component {
  render(){
    return (
      <div>
        <LlenaCedula/>
      </div>
    )
  }
}
export default CedCapa;